import request from '@/utils/request'
import store from "../store";
import { Toast } from 'vant';

export function loadData(url,data) {
  return request({url: url,method: 'post',data})
}

export function initConfig(succ) {
  loadData('/appIndex/queryConfig',{}).then(res => {
    if(res && res.code == 0){
      sessionStorage.setItem('config_seat_maxh',res.data.config_seat_maxh);
	  sessionStorage.setItem('config_seat_minh',res.data.config_seat_minh);
	  sessionStorage.setItem('config_seat_maxday',res.data.config_seat_maxday);
	  sessionStorage.setItem('config_sroom_maxh',res.data.config_sroom_maxh);
	  sessionStorage.setItem('config_sroom_minh',res.data.config_sroom_minh);
	  sessionStorage.setItem('config_sroom_maxday',res.data.config_sroom_maxday);
	  if(succ){
		  succ();
	  }
    }
  }).catch(() => {
    //this.listLoading = false
  }) 
}


export function checkLogin(err,succ) {
  let userId = sessionStorage.getItem('login_userid');
  //let userCard = sessionStorage.getItem('login_usercard');
  let token = sessionStorage.getItem('login_token');
  if(userId && token){
    if(succ){
        succ();
    }
  }else{
    if(err){
       err();
    }else{
       window.location.href = '/api/cas/login';
    }
  }
}

export function showToastMsg(msg) {
  Toast.loading({
    message: msg,
    forbidClick: true,
    duration:1500
  });
}

export function showToast(t) {
  t = t ? t : 0;
  Toast.loading({
    message: '加载中...',
    forbidClick: true,
    duration:t
  });
}

export function hideToast() {
  Toast.clear();
}




